export default "__VITE_ASSET__CdkYMNfY__"